import { render } from "./NcrmPrivacyRecordTab.vue?vue&type=template&id=67826df9&scoped=true"
import script from "./NcrmPrivacyRecordTab.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyRecordTab.vue?vue&type=script&lang=js"

import "./NcrmPrivacyRecordTab.vue?vue&type=style&index=0&id=67826df9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67826df9"]])

export default __exports__